import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HubEscuelas from "./pages/HubEscuelas";
import EscuelaLanding from "./pages/EscuelaLanding";
import ScrollToTop from "./components/ScrollToTop";

function App() {
    return (
        <div className="App min-h-screen bg-background text-foreground">
            <BrowserRouter>
                <ScrollToTop />
                <Navbar />
                <main>
                    <Routes>
                        <Route path="/" element={<HubEscuelas />} />
                        <Route path="/:slug" element={<EscuelaLanding />} />
                    </Routes>
                </main>
                <Footer />
                <Toaster position="top-right" richColors />
            </BrowserRouter>
        </div>
    );
}

export default App;
